module.exports = __webpack_public_path__ + "img/hoveyh.3e28a1bc.png";